import { QuoteBindingSearchRequestQuery } from '@lio/api-types';

export const quoteBindingQueryKey = {
  resource: 'quoteBinding' as const,
  get: (quoteId?: string) => [quoteBindingQueryKey.resource, quoteId] as const,
  getWithParams: (quoteId?: string, id?: string) => [...quoteBindingQueryKey.get(quoteId), 'binding', id] as const,
  searchWithParams: (quoteId?: string, params?: QuoteBindingSearchRequestQuery) =>
    [...quoteBindingQueryKey.get(quoteId), params] as const,
};

export const quoteQueryKey = {
  resource: 'quote' as const,
  get: (quoteId?: string) => [quoteQueryKey.resource, { quoteId }] as const,
  diff: (quoteIdTarget?: string) => [quoteQueryKey.resource, quoteIdTarget, 'diff'] as const,
  diffForms: (quoteIdSource?: string, quoteIdTarget?: string) =>
    [quoteQueryKey.resource, 'diff-forms', { quoteIdSource, quoteIdTarget }] as const,
};
